
    // TEXT input for "ProductOverview"
    const input = {
    // Product REVIEWS
    reviews: {
        href: 'https://www.google.com/',
        average: 4,
        totalCount: 117
    },

    // Product DESCRIPTIONS
    product: {
        // General Information about the product
        name: 'Loose Pants',
        price: '$60',
        to: '/women/clothing/zara2/Zara2',
        id: 'product-women-zara2',
        
        // Product Breadcrumbs
        breadcrumbs: [
            { id: 1, name: 'Women', to: '/women/clothing' },
            // { id: 2, name: 'Clothing', to:'/women/clothing'},
            // { id: 3, name: 'Bottoms', to: '/men/clothing/bottoms' },
        ],

        //Product Images
        images: [
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/3/product_women_3-1.jpg',
            alt: 'image 1',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/3/product_women_3-2.jpg',
            alt: 'image 2',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/3/product_women_3-3.jpg',
            alt: 'image 3',
            },
            {
            src: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/3/product_women_3-4.jpg',
            alt: 'image 4',
            },
        ],

        // Product Colors
        colors: [
            { name: 'White', class: 'bg-white', selectedClass: 'ring-gray-400' },
            { name: 'Gray', class: 'bg-gray-200', selectedClass: 'ring-gray-400' },
            { name: 'Black', class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
        ],

        // Product Sizing
        sizes: [
            { name: '32', inStock: true },
            { name: '34', inStock: true },
            { name: '36', inStock: true },
            { name: '38', inStock: true },
            { name: '40', inStock: true },
            { name: '42', inStock: true },
            { name: '44', inStock: true },
            { name: '46', inStock: true },
            { name: '48', inStock: true },
            { name: '50', inStock: true },
            { name: '52', inStock: true },
            { name: '54', inStock: true },
            { name: '56', inStock: true },
        ],

        // Product Introduction
        description:
            'Slim fit pants with front pockets and back welt pockets. Flap patch pockets at legs. Front zip and button closure.',
        
        // Product Bulletpoints
        highlights: [
            'Machine wash max',
            'Do not dry clean',
            'Low temperature dryer may be used',
            '98% cotton',
            '2% elastane',
        ],
        
        // Product Additional Information
        details:
            "Embrace ultimate comfort with our Loose Pants. Designed with a relaxed fit through the leg, they offer unrestricted movement and a contemporary silhouette. Ideal for laid-back days or an effortlessly chic look.",
    },

    // Personalized Recommendation per Product
    recommendation: [
        {
            id: 1,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/women/clothing/tops/nike1',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/1/product_women_1-1.jpeg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        {
            id: 2,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/women/clothing/bottoms/zara1',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/2/product_women_2-1.jpeg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        // {
        //     id: 3,
        //     name: 'Basic Tee',
        //     category: "Men's T-Shirts",
        //     href: '/women/clothing/bottoms/zara2',
        //     imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/3/product_women_3-1.jpg',
        //     imageAlt: "Front of men's Basic Tee in black.",
        //     price: '$35',
        //     color: 'Black',
        // },
        {
            id: 4,
            name: 'Basic Tee',
            category: "Men's T-Shirts",
            href: '/women/clothing/tops/nike4',
            imageSrc: 'https://storage.googleapis.com/esenca-static-hosting/demo-shop/products/women/4/product_women_4-1.jpg',
            imageAlt: "Front of men's Basic Tee in black.",
            price: '$35',
            color: 'Black',
        },
        // More products...
    ]

    }

    export default input
    
